var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.918,
    height: 7.906,
    viewBox: "0 0 7.918 7.906",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3c9cf9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.3,29.277h4.167a1.5,1.5,0,0,0,1.5-1.5V25.225a.341.341,0,0,0-.347-.347h0a.341.341,0,0,0-.347.347v2.547a.805.805,0,0,1-.81.81H17.3a.805.805,0,0,1-.81-.81V23.6a.805.805,0,0,1,.81-.81h2.547a.347.347,0,1,0,0-.695H17.3a1.5,1.5,0,0,0-1.5,1.5h0v4.167A1.5,1.5,0,0,0,17.3,29.277Z",
    transform: "translate(-15.8 -21.371)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M49.98,18.277V16.159a.147.147,0,0,0-.012-.069c0-.012,0-.023-.012-.023s-.012-.023-.012-.035-.012-.023-.023-.035a.04.04,0,0,0-.012-.023.352.352,0,0,0-.093-.093l-.023-.012a.084.084,0,0,0-.069-.046l-.035-.012c-.023,0-.046-.012-.069-.012H47.5a.347.347,0,1,0,0,.695h1.285L45.6,19.689a.344.344,0,0,0,.486.486l3.195-3.183v1.285a.341.341,0,0,0,.347.347h0A.364.364,0,0,0,49.98,18.277Z",
    transform: "translate(-42.062 -15.8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.377242145c73609d68b9f51b4b6f045f.svg";
export { ForwardRef as ReactComponent };